<template>
    <div v-if="Object.keys(order).length !== 0" class="row p-2">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <div class="row py-4 align-items-center">
                        <div class="col-12">
                            <h2>{{ $t("orders.order") }} - {{ order.intern_id }}</h2>
                        </div>
                        <!-- Buttons -->
                        <div v-if="$store.getters.hasPerm('change_order')" class="col-12 d-block my-1">
                            <router-link :to="'/order/' + this.orderId + '/items'"
                                class="button-top float-left mr-1 me-2 btn my-1" v-if="!order.hidden">{{
                                    $t("orders.editOrder") }}</router-link>
                            <button @click="copy()" class="button-top float-left mr-1 me-2 btn my-1">{{
                                $t("orders.copyOrder") }}</button>
                            <button @click="done()" class="button-top float-left mr-1 me-2 btn my-1"
                                v-if="!order.hidden && !order.done">
                                {{ $t("orders.orderFinished") }}
                            </button>
                            <!-- Delivery note popup -->
                            <DeliveryNotePopup v-if="$store.getters.hasPerm('can_export_delivery_notes')"
                                :orderId="this.orderId" :suppliers="this.suppliers" />
                            <button @click="restore()" class="button-top float-left mr-1 me-2 btn my-1"
                                v-if="order.hidden">
                                {{ $t("orders.restoreOrder") }}
                            </button>
                            <button @click="undone()" class="button-top float-left mr-1 me-2 btn my-1"
                                v-if="order.done">
                                {{ $t("orders.undoneOrder") }}
                            </button>
                            <button @click="hide()" class="button-top float-left mr-1 me-2 btn my-1"
                                v-if="!order.hidden">{{
                                    $t("orders.cancelOrder") }}
                            </button>
                            <!-- If order was paid with cash -->
                            <button @click="paid()" class="button-top float-left mr-1 me-2 btn my-1"
                                v-if="isOwnerOrDispecher() && !order.collected_revenue_by && order.pay_by_cash">
                                <span>{{ $t("orders.collectedRevenue") }}</span>
                            </button>
                            <!-- Elif order was paid with transfer or QR code -->
                            <button @click="paid()" class="button-top float-left mr-1 me-2 btn my-1"
                                v-if="isOwnerOrDispecher() && !order.collected_revenue_at && !order.pay_by_cash">
                                <span>{{ $t("orders.markAsPaid") }}</span>
                            </button>
                            <!-- Return revenue -->
                            <button @click="returnRevenue()" class="button-top float-left mr-1 me-2 btn my-1"
                                v-if="isOwnerOrDispecher() && order.collected_revenue_at && order.pay_by_cash">
                                <span>{{ $t("orders.returnRevenue") }}</span>
                            </button>
                            <button @click="generateQR()" class="button-top float-left mr-1 me-2 btn my-1"
                                data-bs-toggle="modal" data-bs-target="#QRCode"
                                v-if="!order.pay_by_cash && isOwnerOrDispecher()">
                                <span>{{ $t("orders.generateQR") }}</span>
                            </button>
                            <!-- QR CODE -->
                            <Popup v-if="!order.pay_by_cash" :header="$t('orders.payWithQR')" :editable="false"
                                id="QRCode">
                                <template v-slot:body>
                                    <div class="w-50 mx-auto mb-5">
                                        <label class="form-label">{{ $t('orders.selectSupplier') }}</label>
                                        <select class="form-select" v-model="selectedSupplier" id="supplier">
                                            <option v-for="supplier in suppliers" :value="supplier.id">
                                                {{ supplier.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="roundedWarningMessage" class="mb-2 d-flex justify-content-center"
                                        style="font-weight: 700;">
                                        <span>{{ roundedWarningMessage }}</span>
                                    </div>
                                    <div class="d-flex w-100">
                                        <img v-if="this.qrCode && this.selectedSupplier" :src="this.qrCode"
                                            alt="QR kód pro platbu" class="qrcode mx-auto"
                                            style="width: 350px; height: 350px" />
                                    </div>
                                </template>
                            </Popup>
                            <button class="button-top float-left mr-1 me-2 btn my-1" data-bs-toggle="modal"
                                data-bs-target="#emailQR" v-if="!order.pay_by_cash && isOwnerOrDispecher()">
                                <span>{{ $t("orders.sendEmailWithQR") }}</span>
                            </button>
                            <!-- Email QR CODE -->
                            <div class="modal fade" id="emailQR" tabindex="-1" aria-labelledby="emailQRLabel"
                                aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="emailQRLabel">{{ $t('orders.payWithQR') }}</h5>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body">
                                            <div v-if="!order.customer.email" class="mb-2 d-flex">
                                                <span>{{ $t("orders.customerEmailNotFound") }}</span>
                                            </div>
                                            <div v-if="order.customer.email">
                                                <div v-if="sentEmailQR">
                                                    <span style="color: green;">{{ $t("orders.sentEmailQR") }}</span>
                                                </div>
                                                <div class="w-50 mb-5">
                                                    <label class="form-label">{{ $t('orders.selectSupplier') }}</label>
                                                    <select class="form-select" v-model="selectedSupplier"
                                                        id="supplier">
                                                        <option v-for="supplier in suppliers" :value="supplier.id">
                                                            {{ supplier.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div v-if="selectedSupplier">
                                                    <span style="font-size: 16px;">
                                                        {{ $t("orders.sendEmailWithQR") }}?
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-if="order.customer.email && selectedSupplier"
                                                class="mt-3 d-flex justify-content-end">
                                                <button type="button" class="btn btn-secondary me-2"
                                                    data-bs-dismiss="modal">{{ $t("utils.close")
                                                    }}</button>
                                                <button type="button" class="btn btn-primary" @click="sendEmailQR()">
                                                    <span>{{ $t("utils.submit") }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <span>{{ $t("orders.orderFinished") }}:
                        <span v-if="order.done">{{ $t("orders.yes") }}</span>
                        <span v-else>{{ $t("orders.no") }}</span>
                    </span>
                </div>
                <div class="col-12 col-md-6">
                    <span>{{ $t("orders.orderReady") }}:
                        <span v-if="order.prepared || order.done">{{ $t("orders.yes") }}</span>
                        <span v-else>{{ $t("orders.no") }}</span>
                    </span>
                </div>
                <div v-if="order.pay_by_cash" class="col-12">
                    <span>{{ $t("orders.collectedRevenue") }}:
                        <span v-if="order.collected_revenue_by">{{ $t("orders.yes") }}</span>
                        <span v-else>{{ $t("orders.no") }}</span>
                    </span>
                </div>
                <div v-else class="col-12">
                    <span>{{ $t("orders.paid") }}:
                        <span v-if="order.collected_revenue_by">{{ $t("orders.yes") }}</span>
                        <span v-else>{{ $t("orders.no") }}</span>
                    </span>
                </div>
                <!-- Customer -->
                <div class="col-12 col-md-6 mt-5">
                    <div class="row">
                        <div class="col-12">
                            <h3>{{ $t("customer.customer") }}</h3>
                        </div>
                        <div class="col-12">
                            <span>{{ $t("customer.firstName") }}: <b class="ms-1">{{ order.customer.first_name }} {{
                                order.customer.last_name
                                    }}</b></span>
                        </div>
                        <div v-if="order.customer.organization_id">
                            <div class="col-12">
                                <span>{{ $t("customer.organizationId") }}: <b class="ms-1">{{
                                    order.customer.organization_id
                                        }}</b></span>
                            </div>
                            <div class="col-12">
                                <span>{{ $t("customer.organizationName") }}: <b class="ms-1">{{
                                    order.customer.organization_name }}</b></span>
                            </div>
                        </div>
                        <div class="col-12">
                            <span>{{ $t("customer.phone") }}: <b><a :href="'tel:' + order.customer.whole_phone"
                                        class="phone-number link-darker ms-1">
                                        {{ order.customer.whole_phone }}</a></b>
                            </span>
                        </div>
                        <div v-if="order.customer.email" class="col-12">
                            <span>{{ $t("customer.email") }}: <b>
                                    <a :href="'mailto:' + order.customer.email" class="link-darker ms-1">
                                        {{ order.customer.email }}
                                    </a></b>
                            </span>
                        </div>
                        <div class="col-12">
                            <span>{{ $t("customer.address") }}:</span>
                            <span class="ms-1">
                                <b><a :href="order.customer.address.waze" class="link-darker" target="_blank">
                                        {{ order.customer.address.full_address }}
                                        <br><br>{{ $t("orders.wazeAddress") }}</a></b>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- Intern info -->
                <div class="col-12 col-md-6 mt-5">
                    <h3>{{ $t("orders.internInfo") }}</h3>
                    <div class="row">

                        <div class="col-12 mt-1">
                            <span v-if="order.special_mark" class="badge bg-danger">⚠ {{
                                $t("orders.specialMarkShort") }}</span>
                        </div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.internNumber") }}</div>
                        <div class="col-12 col-md-6 mt-1"><b>{{ order.intern_id }}</b></div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.created") }}:</div>
                        <div class="col-12 col-md-6 mt-1"><b>{{ order.created }}</b></div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.createdBy") }}:</div>
                        <div class="col-12 col-md-6 mt-1">
                            <b>
                                <span v-if="order.created_by">{{ order.created_by.first_name }} {{
                                    order.created_by.last_name }} ({{ order.created_by.username }})</span>
                                <span v-else>{{ $t("orders.unknownCreator") }}</span>
                            </b>
                        </div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.expectedDateTime") }}:</div>
                        <div class="col-12 col-md-6 mt-1"><b>{{ order.expected_delivery_date }} {{
                            order.expected_delivery_time }}</b></div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.clientDistance") }}:</div>
                        <div class="col-12 col-md-6 mt-1"><b><span>{{ order.distance }} km ({{ order.duration }}
                                    {{ $t("orders.minutes") }})</span></b></div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.expectedTimeSpend") }}:</div>
                        <div class="col-12 col-md-6 mt-1"><b>{{ order.expected_delivery_duration }} {{
                            $t("orders.minutes") }}</b></div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.productPrice") }}:</div>
                        <div class="col-12 col-md-6 mt-1"><b>{{ formatNumber(order.product_prices, 2) }} {{
                            order.currency
                                }}</b></div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.deliveryPrice") }}:</div>
                        <div class="col-12 col-md-6 mt-1"><b>{{ formatNumber(delivery_price_total, 2) }} {{
                            order.currency }}</b>
                        </div>
                        <div class="">
                            <div v-if="order.total_price_after_sale" class="row">
                                <div class="col-12 col-md-6 mt-1">{{ $t("orders.priceWIthoutVatAfterSale") }}:</div>
                                <div class="col-12 col-md-6 mt-1"><b>{{ formatNumber(order.total_price_after_sale, 2) }}
                                        {{ order.currency }}
                                        (<s>{{ formatNumber(order.total_price, 2) }} {{ order.currency }}</s>)
                                    </b>
                                </div>
                                <div class="col-12 col-md-6 mt-1">{{ $t("orders.priceWithVatAfterSale") }}:</div>
                                <div class="col-12 col-md-6 mt-1"><b>{{ formatNumber(order.total_price_vat_after_sale,
                                    2) }}
                                        {{ order.currency }}
                                        <span>(<s>{{ formatNumber(order.total_price_vat, 2) }} {{ order.currency
                                                }}</s>)</span>
                                    </b>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-12 col-md-6 mt-1">{{ $t("orders.priceNoVat") }}:</div>
                                <div class="col-12 col-md-6 mt-1"><b>{{ formatNumber(order.total_price, 2) }}
                                        {{ order.currency }}
                                    </b>
                                </div>
                                <div class="col-12 col-md-6 mt-1">{{ $t("orders.priceVat") }}:</div>
                                <div class="col-12 col-md-6 mt-1"><b>{{ formatNumber(order.total_price_vat,
                                    2) }}
                                        {{ order.currency }}
                                    </b>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.warehouse") }}:</div>
                        <div class="col-12 col-md-6 mt-1">
                            <b>
                                <span v-if="order.warehouse"><a :href="order.warehouse.address.waze" class="link-darker"
                                        target="_blank">{{ order.warehouse.name }}<br>{{
                                            order.warehouse.address.full_address }}</a></span>
                                <span v-else>{{ $t("orders.noWarehouse") }}</span>
                            </b>
                        </div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.driver") }}:</div>
                        <div class="col-12 col-md-6 mt-1">
                            <b>
                                <span v-if="order.driver">{{ order.driver.first_name }} {{ order.driver.last_name }}
                                    ({{ order.driver.username }})</span>
                                <span v-else>{{ $t("orders.personalCollect") }}</span>
                            </b>
                        </div>
                        <div v-if="order.car" class="col-12 col-md-6 mt-1">
                            <span>{{ $t("warehouses.car") }}:</span>
                        </div>
                        <div v-if="order.car" class="col-12 col-md-6 mt-1">
                            <span>{{ order.car.name }}</span>
                        </div>
                        <div class="col-12 col-md-6 mt-1">{{ $t("orders.note") }}:</div>
                        <div class="col-12 col-md-6 mt-1">
                            <span v-if="order.note">{{ order.note }}</span>
                            <span v-else>{{ $t("orders.noNote") }}</span>
                        </div>
                    </div>
                </div>
                <!-- Order items -->
                <div class="col-12 mt-5">
                    <h3>{{ $t("orders.items") }}</h3>
                    <div v-if="order.products" v-for="product in order.products" :key="product.id" class="row">
                        <div class="col-12 col-md-4">
                            <div class="panel panel-default card-input m-3 font-weight-bold"
                                style="opacity: 1; cursor: auto;">
                                <div class="panel-heading py-2 px-4 d-flex justify-content-between">
                                    <span>{{ product.product.product.name }}</span>
                                    <div v-if="!order.done && !product.prepared">
                                        <span @click="productReady(product.id)" class="float-right btn-product-ready"
                                            style="cursor: pointer">{{
                                                $t("orders.getReady") }}</span>
                                    </div>
                                    <div v-else>
                                        <span>{{ $t("orders.ready") }}</span>
                                    </div>
                                </div>
                                <div class="panel-body py-2 px-4">
                                    <span>{{ $t("products.type") }}: {{ product.product.product.type }}</span><br>
                                    <span>{{ $t("products.length") }}: {{ product.product.product.length }}
                                        cm</span><br>
                                    <span>{{ $t("products.amount") }}: {{ product.amount }} {{
                                        product.product.product.measurement_unit
                                        }}</span><br>
                                    <span>{{ $t("orders.ready") }}:
                                        <span v-if="product.prepared">{{ $t("orders.yes") }}</span>
                                        <span v-else>{{ $t("orders.no") }}</span>
                                    </span><br>
                                    <div v-if="$store.getters.hasPerm('change_order')">
                                        <span>{{ $t("products.unitPrice") }}: {{ formatNumber(product.product.amount, 2)
                                            }} {{ product.product.currency }}</span><br>
                                        <span>{{ $t("products.totalPrice") }}: {{ formatNumber(product.product.amount *
                                            product.amount, 2) }} {{ product.product.currency }}</span><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="col-12">{{ $t("orders.noItems") }}</div>
                </div>
            </div>
            <div class="col-12 mt-3">
                <FilesContainer :files="order.files" :orderFileContainer="true" @uploadFile="uploadFile"
                    @deleteFile="deleteFile" @downloadFile="downloadFile" />
            </div>
        </div>

    </div>
</template>
<script>
import DeliveryNotePopup from "@/components/DeliveryNotePopup.vue"
import Popup from "@/components/Popup.vue";
import FilesContainer from "@/components/FilesContainer.vue";

export default {
    components: {
        DeliveryNotePopup,
        Popup,
        FilesContainer
    },
    data() {
        return {
            order: {},
            warehouse_car: {},
            suppliers: [],
            selectedSupplier: null,
            orderId: null,
            qrCode: "",
            sentEmailQR: false,
            roundedWarningMessage: null,
            qrWarningMessage: null
        }
    },
    created() {
        this.orderId = this.$route.params.id;
        this.loadData();
    },
    computed: {
        delivery_price_total: function () {
            if (this.order == {}) {
                return 0;
            }
            var price = this.order.delivery_price.amount * this.order.distance * 2;
            if (price < this.order.delivery_price.minimum_price) {
                price = this.order.delivery_price.minimum_price;
            }
            return price;
        }
    },
    watch: {
        selectedSupplier: function () {
            this.generateQR();
        }
    },
    methods: {
        loadData: function () {
            this.$store.getters.api.get("/order/" + this.orderId).then((response) => {
                this.order = response.data.item;
                if (this.order.default_supplier) {
                    this.selectedSupplier = this.order.default_supplier.id;
                } else {
                    this.selectedSupplier = null;
                }
            })
            this.$store.getters.api.get("/suppliers").then((response) => {
                this.suppliers = response.data.items;
            })
        },
        copy: function () {
            this.$store.getters.api.get("/order/" + this.orderId + "/copy").then((response) => {
                this.$router.push("/order/" + response.data.order_id + "/items");
            })
        },
        restore: function () {
            this.$store.getters.api.put("/order/" + this.orderId + "/restore").then(function () {
                this.loadData();
            }.bind(this))
        },
        done: function () {
            this.$store.getters.api.put("/order/" + this.orderId + "/done").then(function () {
                this.loadData();
            }.bind(this))
        },
        hide: function () {
            this.$store.getters.api.delete("/order/" + this.orderId + "/delete").then(function () {
                this.loadData();
            }.bind(this))
        },
        undone: function () {
            this.$store.getters.api.put("/order/" + this.orderId + "/undone").then(function () {
                this.loadData();
            }.bind(this))
        },
        paid: function () {
            this.$store.getters.api.put("/order/" + this.orderId + "/collect_revenue").then((response) => {
                this.loadData();
            })
        },
        returnRevenue: function () {
            this.$store.getters.api.put("/order/" + this.orderId + "/return_revenue").then((response) => {
                this.loadData();
            })
        },
        productReady: function (product_id) {
            this.$store.getters.api.put("/order/" + this.orderId + "/" + product_id + "/prepared").then(function () {
                this.loadData();
            }.bind(this))
        },
        isOwnerOrDispecher: function () {
            var isOwnerOrDispecher = false;
            this.$store.state.user.functions.forEach(element => {
                if (element.name == "owner") {
                    isOwnerOrDispecher = true;
                }
                else if (element.name == "dispatcher") {
                    isOwnerOrDispecher = true;
                }
            })
            return isOwnerOrDispecher;
        },
        generateQR: function () {
            if (this.selectedSupplier && this.order) {
                const supplier = this.suppliers.find(s => s.id === this.selectedSupplier);
                const totalPrice = Math.round(Number(this.order.total_price_vat_after_sale || this.order.total_price_vat));
                this.roundedWarningMessage = "Částka zaokrouhlena z " + (this.order.total_price_vat_after_sale || this.order.total_price_vat) + " CZK" + " na " + totalPrice + " CZK";

                const paymentAccount = supplier.bank_account;
                const bankCode = supplier.bank_code;
                this.qrCode = "https://api.paylibo.com/paylibo/generator/czech/image?accountNumber=" + paymentAccount
                    + "&bankCode=" + bankCode
                    + "&amount=" + totalPrice
                    + ".00&currency=CZK&vs=" + this.order.intern_id
                    + "&message=" + "" + "&size=200";
            }
        },
        sendEmailQR: function () {
            if (this.selectedSupplier) {
                this.$store.getters.api.post("/order/" + this.orderId + "/send_email_qr", { supplier_id: this.selectedSupplier }).then((response) => {
                    this.sentEmailQR = true;
                })
            }
        },
        uploadFile: function (data) {
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("file_type", data.file_type);
            formData.append("file", data.file);

            this.$store.getters.api.post("/order/" + this.orderId + "/files/add", formData).then((response) => {
                this.loadData();
            })
        },
        deleteFile: function (id) {
            this.$store.getters.api.delete("/order/" + this.orderId + "/files/" + id + "/delete").then((response) => {
                this.loadData();
            })
        },
        downloadFile: function (documentItem) {
            const fileName = documentItem.name || 'downloaded_document';

            this.$store.getters.api.get("/order/" + this.orderId + "/files/" + documentItem.id + "/download", {
                responseType: 'blob'
            }
            ).then((response) => {
                if (response.data) {
                    const documentItem = response.data;
                    // Create a Blob URL using the provided Blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));

                    // Create a link element to trigger the download
                    const link = window.document.createElement('a');

                    // Set the filename from the server or fallback to a default name
                    const fileExtension = documentItem.type.split('/')[1];  // Extract extension (e.g., 'pdf' from 'application/pdf')
                    link.href = url;

                    // Use the Blob type to determine the filename with extension
                    link.setAttribute('download', `${fileName}.${fileExtension}`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    this.loadData();
                }
            })
        }
    },
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";

.button-top {
    background-color: $primary;
    color: $white;
}

.btn-product-ready {
    border: 1px solid transparent;
    background-color: $primary;
    color: $white;
    padding: 5px 10px;
    border-radius: 4px;
    color: white;

    &:hover {
        color: black;
        border: 1px solid $primary;
        background-color: transparent;
    }
}

.panel {
    border: 2px solid $primary;
    border-radius: 25px;
    font-weight: bold;

    .panel-heading {
        border-bottom: 1px solid $primary;
    }
}
</style>